import { TemplateOptionsReader } from "./enums.js";
import { ApiEntity, } from "./types/index.js";
import { getObjectValue } from "./utils/index.js";
export function isExtent(val) {
    return (val instanceof Object &&
        typeof val.top === "number" &&
        typeof val.right === "number" &&
        typeof val.bottom === "number" &&
        typeof val.left === "number");
}
export function isGeometryCollection(val) {
    return val.type === "GeometryCollection" /* GeometryType.GeometryCollection */;
}
export function isPoint(val) {
    return val.type === "Point" /* GeometryType.Point */;
}
export function isMultiPoint(val) {
    return val.type === "MultiPoint" /* GeometryType.MultiPoint */;
}
export function isLineString(val) {
    return val.type === "LineString" /* GeometryType.LineString */;
}
export function isMultiLineString(val) {
    return val.type === "MultiLineString" /* GeometryType.MultiLineString */;
}
export function isPolygon(val) {
    return val.type === "Polygon" /* GeometryType.Polygon */;
}
export function isMultiPolygon(val) {
    return val.type === "MultiPolygon" /* GeometryType.MultiPolygon */;
}
export function isMapShapeResponse(val) {
    if (!val)
        return false;
    for (const i in val) {
        const shapes = val[i][1];
        for (const i in shapes) {
            const val = shapes[i];
            if (val instanceof Array)
                return false;
        }
    }
    return true;
}
export function isAtlasShapeResponse(val) {
    if (!val)
        return false;
    for (const i in val) {
        const shapes = val[i][1];
        for (const i in shapes) {
            const val = shapes[i];
            if (typeof val === "string")
                return false;
        }
    }
    return true;
}
export function isMapCentroidResponse(val) {
    if (!val)
        return false;
    const values = val;
    try {
        for (const i in values) {
            if (!values[i].centroid)
                throw new Error("invalid centroid");
        }
        return true;
    }
    catch (e) {
        return false;
    }
}
export function isAtlasCentroidResponse(val) {
    if (!val)
        return false;
    const values = val;
    try {
        for (const i in values) {
            for (const k in values[i]) {
                if (!values[i][k].centroid)
                    throw new Error("invalid centroid");
            }
        }
        return true;
    }
    catch (e) {
        return false;
    }
}
export function isValidOption(options) {
    if (!(options instanceof Object))
        return false;
    return (Object.prototype.hasOwnProperty.call(options, "serverUrl") &&
        Object.prototype.hasOwnProperty.call(options, "token"));
}
export function isValidBaseOption(options) {
    return isValidOption(options);
}
export function isValidSearchPinOption(options) {
    if (!(options instanceof Object))
        return false;
    if (!isValidBaseOption(options))
        return false;
    return (Object.prototype.hasOwnProperty.call(options, "search") ||
        Object.prototype.hasOwnProperty.call(options, "pin"));
}
export function isValidAtlasOption(options) {
    if (!isValidBaseOption(options))
        return false;
    return !!options[ApiEntity.Atlas];
}
export function isJsonProperties(val) {
    if (!(val instanceof Object))
        return false;
    let valid = true;
    const keys = Object.keys(val);
    const values = Object.values(val);
    for (const i in keys) {
        const value = values[i];
        if (!["string", "number", "undefined", "object", "boolean"].includes(typeof value)) {
            valid = false;
        }
        else if (value instanceof Object)
            valid = isJsonProperties(value);
        if (!valid)
            break;
    }
    return true;
}
export function isTemplateOption(val) {
    let ret = false;
    for (const key of TemplateOptionsReader.values()) {
        if (key === val) {
            ret = true;
            break;
        }
    }
    return ret;
}
export function isTemplateValue(val) {
    return typeof getObjectValue(val, "header") === "string";
}
export function isTemplateNumberValue(val) {
    if (!isTemplateValue(val))
        return false;
    return (["string", "undefined"].includes(typeof getObjectValue(val, "min")) &&
        ["string", "undefined"].includes(typeof getObjectValue(val, "max")));
}
export function isTemplateColorValue(val) {
    if (!isTemplateNumberValue(val))
        return false;
    const colors = getObjectValue(val, "colors");
    if (!(colors instanceof Array))
        return false;
    return !colors.find((item) => typeof item !== "string");
}
